<template>
	<div id="eventDom" style="height: 100%;">
		<div class="title-top">
			<div style="display: flex;">
				<img src="../../../../static/imgV2/detail-title.png" alt="">
				<div class="title-top-text">{{ languageJson.EventWarnRealTime }}</div>
			</div>
			<div style="height: 2vw;">
				<div v-if="tabPosition == 'untreated' && positionType != '1'" class="btn1" @click='oneHandle()'>{{ languageJson.OneClickProcessing }}</div>
			</div>
		</div>
		<div class="echarsTop">
			<div class="echarsLi">
				<div class="liTap">
					<div class="tap-li" @click="changeRightTopCheck(1)">
						<img :src="rightTopCheck == 1 ? selectImg0 : selectImg1" alt="">
						<div class="tap-name">
							<span>{{ languageJson.untreated }}</span>
							<span
								class="ls">{{ tabPosition == 'untreated' ? checkRightUl.length : rightUl.length - checkRightUl.length }}</span>
						</div>
					</div>
					<div class="tap-li" @click="changeRightTopCheck(2)" style="margin-left: 20px;">
						<img :src="rightTopCheck == 2 ? selectImg0 : selectImg1" alt="">
						<div class="tap-name">
							<span>{{ languageJson.processed }}</span>
							<span
								class="ls">{{ tabPosition == 'treated' ? checkRightUl.length : rightUl.length - checkRightUl.length }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="selet">
			<el-select v-model="eventValue" @change="selectEvent(eventValue)" :placeholder="languageJson.PleaseSelect" clearable>
				<el-option v-for="(item, $index) in typeList" :key="$index" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
		</div>

		<div class="ul">
			<div class="li">{{ languageJson.clockIn }}</div>
			<div class="li">{{ languageJson.eventType }}</div>
			<div class="li">{{ languageJson.Time }}</div>
			<div class="li">{{ languageJson.Status }}</div>
		</div>

		<div style="height: 20vw;">
			<div v-if="searchLeng"
				style="width: 100%;padding: 20px 0;font-size: 0.9vw;font-weight: 600;color: white;">
				<img src="../../../../static/imgV2/none.png" style="width: 30%;" alt="">
				<div style="margin-top: 10px;">{{ languageJson.noneData }}</div>
			</div>
			<div class="hig" v-if="showTime">
				<div class="check_li" v-for="(obj, index) in countRightUl" :key="index" @click="showRobot(obj)" >
					<div style="width: 20%;text-align: center;">
						<el-tooltip 
							effect="dark" 
							:content="obj.positonName || '-'" 
							placement="top"
							:disabled="!obj.positonName || obj.positonName.length <= 3">
							<span class="positon-name">
								{{ obj.positonName ? (obj.positonName.length > 3 ? obj.positonName.substring(0, 3) + '...' : obj.positonName) : '-' }}
							</span>
						</el-tooltip>
					</div>
					<div style="width: 30%;text-align: left;">
						<span v-if="obj.priorityCode == 'HIGH'" class="zy">{{ languageJson.important }}</span> 
						{{ obj.eName }}
					</div>
					<div style="width: 30%;" :style="{ color: (obj.results == '2' || obj.results == '3') ? 'red' : 'white' }">
						<i class="el-icon-time" v-if="obj.results == '2' || obj.results == '3'"></i>
						{{ obj.eventInsDate }}
					</div>
					<div style="width: 20%;text-align: right;">{{ obj.resultsName }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getEventType,
		getRobotEventDetail,
		getReportEventTypeByRobotId,
		eventTypeByRobotId
	} from '@/api/admin.js'
	import {
		eventTypeByTenantInfoId
	} from '@/api/indexV2.js'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		data() {
			return {
				languageJson: languageJson,
				selectImg0: require('../../../../static/imgV2/checkSelect-0.png'),
				selectImg1: require('../../../../static/imgV2/checkSelect-1.png'),
				robotIcon: require('../../../../static/img/robotIcon.png'),
				photograph: require('../../../../static/img/photograph.png'),
				rightTopCheck: 1,
				tabPosition: 'untreated',
				checkRightUl: [],
				checkEventList: [],
				eventValue: "",
				typeList: [],
				handleRobot: false,
				positionType: getItem('userInfo').positionType,
				showTime: true
			}
		},
		props: ['rightUl', 'type', 'robotNumber'],
		computed: {
			countRightUl() {
				let that = this
				if (that.checkEventList.length > 0) {
					return JSON.parse(JSON.stringify(that.checkEventList.sort(that.compare("disShowFlg"))))
				} else if (!that.eventValue) {
					return JSON.parse(JSON.stringify(that.checkRightUl.sort(that.compare("disShowFlg"))))
				}
			},
			searchLeng() {
				let that = this
				if (that.checkRightUl.length == 0) {
					return true;
				} else {
					if (that.eventValue) {
						if (that.checkEventList.length == 0) {
							return true
						} else {
							return false
						}
					}
				}
			}
		},
		mounted() {
			let that = this
			that.eventTypeByRobotId(this.robotNumber)
		},
		methods: {
			oneHandle() {
				let that = this
				let eventIds = [];
				this.countRightUl.forEach(res => {
					if (res.priorityCode != 'HIGH') eventIds.push(res.eventId)
				})
				if (eventIds.length > 0) {
					that.$emit("oneHandle", eventIds)
				} else {
					that.$notify.warning({
						title: languageJson.noImportantEventsHhandle
					})
				}
			},
			eventTypeByRobotId(id) {
				let that = this
				eventTypeByRobotId(id).then(res => {
					that.typeList = []
					if (res.data.length > 0) {
						res.data.forEach(v => {
							that.typeList.push(v)
						})
					}
				})
			},
			showRobot(obj) {
				this.$emit('ifShowRobot', obj)
			},
			compare(p) {
				return function(m, n) {
					var a = Number(m[p])
					var b = Number(n[p])
					return b - a
				}
			},
			changeRightTopCheck(type) {
				this.rightTopCheck = type
				if (type == 1) {
					this.tabPosition = 'untreated'
				} else {
					this.tabPosition = 'treated'
				}
			},
			selectEvent(eid) {
				let that = this
				that.checkEventList = []
				if (eid) {
					that.checkRightUl.forEach(res => {
						if (res.eName == eid) {
							that.checkEventList.push(res)
						}
					})
					that.showTime = true
				}
			}
		},
		watch: {
			robotNumber: {
				deep: true,
				handler(val, oldVal) {
					let that = this
					that.eventTypeByRobotId(val)
				}
			},
			rightUl: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					let that = this
					that.checkRightUl = []
					for (let i = 0; i < val.length; i++) {
						if (val[i].priorityCode == "HIGH") {
							val[i].disShowFlg = '3'
						} else {
							if (val[i].disShowFlg == '0') {
								val[i].disShowFlg = '1'
							}
						}
					}
					if (that.tabPosition == 'untreated') {
						val.forEach(v => {
							if (v.results == '0' || v.results == '2' || v.results == '4') {
								that.checkRightUl.push(v)
							}
						})
					} else {
						val.forEach(v => {
							if (v.results == '1' || v.results == '3' || v.results == '5') {
								that.checkRightUl.push(v)
							}
						})
					}
					that.selectEvent(that.eventValue)
				}
			},
			tabPosition: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					let that = this
					that.checkRightUl = []
					that.eventValue = ""
					that.checkEventList = []
					if (val == 'untreated') {
						that.handleRobot = false
						that.rightUl.forEach(v => {
							if (v.results == '0' || v.results == '2' || v.results == '4') {
								that.checkRightUl.push(v)
							}
						})
					} else {
						that.handleRobot = true
						that.rightUl.forEach(v => {
							if (v.results == '1' || v.results == '3' || v.results == '5') {
								that.checkRightUl.push(v)
							}
						})
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	::-webkit-scrollbar-track {
	  border-radius: 10px;
	  background-color: #6271a1;
	}

	/*定义滑块 内阴影+圆角*/
	::-webkit-scrollbar-thumb {
	  border-radius: 10px;
	  -webkit-box-shadow: inset 0 0 6px rgb(33, 48, 88, 0.4);
	  background-color:  #6271a1;
	  cursor: pointer;
	}
	.title-top {
		display: flex;
		color: #fff;
		font-size: 0.8vw;
		align-items: flex-start;
		justify-content: space-between;
		margin: 0.6vw 0.5vw 0.1vw 0.5vw;
		padding-bottom: 0.3vw;
		border-bottom: 1px solid rgba(0, 240, 255, 0.1);
		&-text {
			text-shadow: 0 0 10px rgba(0, 240, 255, 0.4);
			background: linear-gradient(180deg, #FFFFFF 0%, #00e0ff 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			font-weight: bold;
			color: #FFFFFF;
			letter-spacing: 2px;
		}

		img {
			width: 1vw;
			margin-right: 0.3vw;
			filter: drop-shadow(0 0 4px rgba(0, 240, 255, 0.5));
		}
	}

	.btn1 {
		background: linear-gradient(135deg, rgba(0, 100, 220, 0.7), rgba(0, 180, 255, 0.5));
		border: 1px solid rgba(0, 240, 255, 0.3);
		border-radius: 4px;
		color: white;
		font-size: 0.7vw;
		padding: 0.2vw 0.6vw;
		margin: 0.1vw 0.5vw;
		cursor: pointer;
		z-index: 99;
		transition: all 0.3s ease;
		text-shadow: 0 0 4px rgba(0, 240, 255, 0.3);
		&:hover {
			box-shadow: 0 0 12px rgba(0, 240, 255, 0.3);
			border-color: rgba(0, 240, 255, 0.6);
			background: linear-gradient(135deg, rgba(0, 120, 240, 0.8), rgba(0, 200, 255, 0.6));
		}
	}

	.selet {
		margin: 12px;
		margin: 0.5vw 10px;
	}

	#eventDom /deep/.el-select {
		width: 98%;
		margin: 0 auto;
	}
	#eventDom /deep/ .el-input--suffix .el-input__inner {
		background: rgba(0, 20, 60, 0.7);
		color: #b0e0ff;
		border: 1px solid rgba(0, 240, 255, 0.15);
		border-radius: 4px;
		height: 1.5vw;
		line-height: 1.5vw;
		font-size: 0.6vw;
		transition: all 0.3s ease;
	}

	#eventDom /deep/ .el-input__icon {
		height: 1.5vw;
		line-height: 1.5vw;
		font-size: 0.6vw;
		color: rgba(0, 240, 255, 0.5);
	}

	#eventDom /deep/ .el-select .el-input,
	.el-select-dropdown .el-select-dropdown__item {
		font-size: 0.7vw;
		height: 1.3vw;
		line-height: 1.3vw;
	}

	.zy {
		background: rgba(200, 30, 60, 0.3);
		padding: 0px 4px;
		border-radius: 2px;
		border: 1px solid rgba(255, 80, 100, 0.5);
		font-size: 0.7vw;
		color: #ff6b7a;
		text-shadow: 0 0 6px rgba(255, 80, 100, 0.3);
		animation: pulseWarn 2s ease-in-out infinite;
	}

	@keyframes pulseWarn {
		0%, 100% { border-color: rgba(255, 80, 100, 0.5); }
		50% { border-color: rgba(255, 80, 100, 0.9); box-shadow: 0 0 8px rgba(255, 80, 100, 0.2); }
	}

	.ul {
		margin: 0 12px;
		height: 24px;
		background: linear-gradient(90deg, rgba(0, 60, 150, 0.5), rgba(0, 30, 80, 0.3));
		border-bottom: 1px solid rgba(0, 240, 255, 0.15);
		display: flex;
		color: rgba(0, 220, 255, 0.9);
		justify-content: space-around;
		align-items: center;
		padding: 1vw;
		box-sizing: border-box;
		font-size: 0.65vw;
		font-weight: 600;
		letter-spacing: 1px;
		text-shadow: 0 0 6px rgba(0, 240, 255, 0.3);
		.li:nth-child(1) {
			width: 20%;
			text-align: left;
		}
		.li:nth-child(2) {
			width: 30%;
			text-align: left;
		}
		.li:nth-child(3) {
			width: 30%;
			text-align: center;
		}
		.li:nth-child(4) {
			width: 20%;
			text-align: right;
		}
	}

	.check_li {
		width: 93.5%;
		margin: 0 auto;
		padding: 0.4vw 0;
		display: flex;
		justify-content: space-around;
		align-items: center;
		font-size: 0.7vw;
		color: #b0d8ff;
		background-color: transparent;
		cursor: pointer;
		border-bottom: 1px solid rgba(0, 240, 255, 0.04);
		transition: all 0.25s ease;
		&:hover {
			background: linear-gradient(90deg, rgba(0, 60, 150, 0.2), transparent);
			color: #e0f0ff;
		}
	}

	.check_li:nth-child(2n+1) {
		background: rgba(0, 20, 60, 0.3);
		&:hover {
			background: linear-gradient(90deg, rgba(0, 60, 150, 0.3), rgba(0, 20, 60, 0.3));
		}
	}

	.uls {
		margin: 0 12px;
		height: 26px;
		background: #0a226e;
		display: flex;
		color: #fff;
		justify-content: space-around;
		align-items: center;
		font-size: 10px;
		padding: 0 12px;
		box-sizing: border-box;

		.li:nth-child(1) {
			width: 40%;
			text-align: left;
		}

		.li:nth-child(2) {
			width: 45%;
			text-align: left;
		}

		.li:nth-child(3) {
			width: 15%;
			text-align: right;
		}

		.img {
			width: 10px;
		}

		.red {
			color: #c64753;
		}
	}

	.uls:nth-child(2n+1) {
		background: inherit;
	}

	.hig {
		width: 98%;
		height: 18vw;
		overflow-x: hidden;
		overflow-y: auto;
		padding-bottom: 1vw;
	}

	.echarsTop {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 5%;
		margin: 6px auto;
		margin-top: 4px;

		.echarsLi {
			display: flex;
			justify-content: space-between;
			width: 96%;
			margin: 0px auto;
			align-items: center;

			.liTap {
				display: flex;
				width: 80%;
				margin: 0 auto;
				gap: 12px;
				justify-content: center;

				.tap-li {
					width: 45%;
					height: 100%;
					position: relative;

					.tap-name {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
						color: #b0d8ff;
						font-weight: 600;
						cursor: pointer;
						font-size: 0.8vw;
						background: rgba(0, 20, 60, 0.5);
						border: 1px solid rgba(0, 240, 255, 0.15);
						border-radius: 4px;
						transition: all 0.3s ease;
						letter-spacing: 1px;
						&:hover {
							border-color: rgba(0, 240, 255, 0.4);
							background: rgba(0, 40, 100, 0.4);
							color: #e0f0ff;
						}
					}

					.ls {
						color: #00f0ff;
						margin-left: 5px;
						font-weight: 700;
						text-shadow: 0 0 8px rgba(0, 240, 255, 0.4);
					}

					img {
						width: 100%;
						height: 100%;
						opacity: 0;
					}
				}
			}
		}
	}
	
	/* 添加打卡点名称样式 */
	.positon-name {
		display: inline-block;
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		cursor: default;
	}
</style>


// WEBPACK FOOTER //
// src/page/robotDetail/components/bottomRight.vue